





























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import {
  CardItem,
  CardItemHead,
  WingBlank,
  MainHead,
  HeadTabs,
} from '@/components/index'
import { EnableList } from '@/api/ObectAdmin'
import {
  PlanExecuteRecordDetail,
  PlanCategorylList,
  PlanSingleDeatil,
  PlanLogExport,
} from '@/api/plainAdmin'
import {
  PlanExecuteRecordDetailForm,
  PlanCategorylListForm
} from '@/types/PlanAdmin'
import { ServerDownLoad } from '@/utils/downFile'
import Search from '../Search/inedx.vue'
import Drawer from '../Drawer/index.vue'
@Component({
  components: {
    MainHead,
    HeadTabs,
    WingBlank,
    Search,
    CardItem,
    CardItemHead,
    Drawer,
  },
})
export default class Main extends Vue {
  headData: string[] = [
    '查看各运营计划的触发及任务执行日志。',
  ];
  headTitle: string = '计划日志';
  HeadImg: string = require('@/assets/images/u28.png');
  // tab切换数据
  tabsArr: any[] = [];
  tabsActive: number = 0;

  /**
   * search 搜索
   * categoryList 选择计划下拉框
   *searchSelectPlan 选择计划下拉
   */
  searchSelectPlan = [];
  searchForm:any = {};
  /**
   *  item头部信息
   */
  headTitleType = 'edit';
  headTitleTypeAdd = 'add';
  /**
   * drawer 抽屉状态
   * drawerForm 抽屉表单
   * drawserTable1
   * drawerObj 数据
   *  */
  drawer: boolean = false;
  drawerObj = {};

  paginationObj = {
    current: 1,
    size: 10,
  };
  // 表格数据
  table = {};

  // 点击tab切换
  handlClickTabs(idx: number) {
    this.tabsActive = idx
    this.paginationObj.current = 1
    this.getPlanPage()
  }

  handleSizeChange(val: number) {
    this.paginationObj.size = val
    this.getPlanPage()
  }
  handleCurrentChange(val: number) {
    this.paginationObj.current = val
    this.getPlanPage()
  }
  // 任务名称按钮
  handleRowNode(id: number) {
    this.getPlanSingleDeatil(id)
  }
  created() {
    this.getEnableList()
  }
  /**
   * 头部tab信息获取
   */
  async getEnableList() {
    const { data } = await EnableList()
    this.tabsArr = data
    this.getPlanCategorylList()
  }

  /**
   * searchForm 搜索提交
   */
  searchSubmit(form: any) {
    const _form = { ...form }
    let timmer:any = null
    timmer = setInterval(() => {
      if (this.tabsArr.length !== 0) {
        if (form.objectId) {
          this.tabsActive = this.tabsArr.findIndex((item:any) => item.id === form.objectId)
        }
        this.searchForm = { ...this.searchForm, ...form }

        this.getPlanPage()
        clearInterval(timmer)
        timmer = null
      }
    })
  }

  /**
   * page分页
   */
  async getPlanPage() {
    const { searchForm, paginationObj } = this
    const objectId = this.tabsArr[this.tabsActive].id
    const params:PlanExecuteRecordDetailForm = { ...searchForm, ...paginationObj, objectId }

    const { data } = await PlanExecuteRecordDetail(params)
    this.table = data
  }
  /**
   * 搜索选择计划下拉框
   * PlanCategorylList
   */
  async getPlanCategorylList() {
    const { tabsArr, tabsActive } = this
    const id = tabsArr[tabsActive].id
    const params:PlanCategorylListForm = { objectId: id }

    const { data } = await PlanCategorylList(params)
    this.searchSelectPlan = data
  }

  /**
   * 详情数据
   * PlanSingleDeatil
   */
  async getPlanSingleDeatil(id: number) {
    const { data } = await PlanSingleDeatil(id)
    data.content = JSON.parse(data.content)
    this.drawerObj = data
    this.drawer = true
  }
  /**
   * 抽屉
   * handleClose 关闭抽屉事件
   */
  handleClose() {
    this.drawer = false
  }

  /**
   * 导出
   * handleExport
   */
  handleExport() {
    const { searchForm, paginationObj } = this
    const objectId = this.tabsArr[this.tabsActive].id
    const params = { ...searchForm, ...paginationObj, objectId }
    ServerDownLoad(PlanLogExport, params)
  }
}
